const STEP = {
  PRODUCT: 1,
  PACKAGING: 2,
  SUBMIT: 3,
};

export default class HeaderProductFinder {
  constructor($el) {
    this.$productSelect = $el.querySelector('select[data-header-product-finder-product]');
    this.$packagingSelect = $el.querySelector('select[data-header-product-finder-packaging]');
    this.$form = $el.querySelector('form[data-header-product-finder-form]');

    this.$stepsContainer = $el.querySelector('.header-product-finder__steps');
    this.$productStep = this.$stepsContainer.querySelector('[data-header-product-finder-step-product]');
    this.$packagingStep = this.$stepsContainer.querySelector('[data-header-product-finder-step-packaging]');
    this.$packagingBack = this.$packagingStep.querySelector('.header-product-finder__step-back');
    this.prepareBack();

    this.actions = JSON.parse($el.getAttribute('data-header-product-finder-actions') || '{}');

    this.activeStepClass = 'header-product-finder__step--active';

    this.state = {
      product: '',
      packaging: '',
    };

    this.bindEvents();
    this.updateSteps();
  }


  prepareBack() {
    const $text = this.$packagingBack.querySelector('.button__text');
    const $backName = document.createElement('span');
    $text.appendChild($backName);
    this.$backName = $backName;
  }

  bindEvents() {
    this.onFilterChangeEvent = this.onFilterChange.bind(this);
    this.$productSelect.addEventListener('change', this.onFilterChangeEvent);
    this.$packagingSelect.addEventListener('change', this.onFilterChangeEvent);
    this.$packagingBack.addEventListener('click', this.onBackClick.bind(this));
  }

  onFilterChange() {
    this.updateSteps();
  }

  onBackClick() {
    HeaderProductFinder.setSelectValue(this.$packagingSelect, '');
    HeaderProductFinder.setSelectValue(this.$productSelect, '');
  }

  updateSteps() {
    this.selectionToState();

    const activeStep = this.getActiveStep();

    this.$form.action = this.stateToAction(this.stepToAction(activeStep));

    if (activeStep === STEP.SUBMIT) {
      this.$form.submit();
      return;
    }

    if (activeStep === STEP.PACKAGING) {
      const $select = this.$productSelect;
      this.$backName.innerText = $select.options[$select.selectedIndex].innerText.trim();
    }

    this.setVisibleStep(activeStep);
  }

  setVisibleStep(activeStep) {
    HeaderProductFinder.conditionalClassName(
      this.$productStep, this.activeStepClass, activeStep === STEP.PRODUCT,
    );
    HeaderProductFinder.conditionalClassName(
      this.$packagingStep, this.activeStepClass, activeStep === STEP.PACKAGING,
    );
  }

  selectionToState() {
    this.state.product = this.$productSelect.value;
    this.state.packaging = this.$packagingSelect.value;
  }

  getActiveStep() {
    if (this.state.product !== '' && this.state.packaging !== '') return STEP.SUBMIT;
    if (this.state.product !== '') return STEP.PACKAGING;

    return STEP.PRODUCT;
  }

  stepToAction(step) {
    switch (step) {
      case STEP.SUBMIT:
        return this.actions.packaging;
      case STEP.PACKAGING:
        return this.actions.product;
      case STEP.PRODUCT:
      default:
        return this.actions.default;
    }
  }

  stateToAction(action) {
    const { product, packaging } = this.state;

    return action.replace(/{product}/g, product).replace(/{packaging}/g, packaging);
  }

  static setSelectValue($select, value = '') {
    const hasOption = Array.from($select.options)
      .findIndex(option => option.value === value) !== -1;
    // eslint-disable-next-line no-param-reassign
    $select.value = hasOption ? value : '';
    $select.dispatchEvent(new Event('change'));
  }

  static conditionalClassName($el, className, condition) {
    if (condition) {
      $el.classList.add(className);
    } else {
      $el.classList.remove(className);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-header-product-finder]').forEach(
    $finder => new HeaderProductFinder($finder),
  );
});
